import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  expandedRoot: {
    padding: '0 !important',
  },
  expandedCard: {
    borderTop: `1px solid ${Theme.palette.gray[250]}`,
  },
  expandedItinerary: {
    display: 'flex',
    flexDirection: 'column',
    margin: '30px 0 30px 70px',
    [Theme.breakpoints.down('sm')]: {
      margin: '20px 20px 20px 50px',
    },
  },
  expandedSeparator: {
    backgroundColor: Theme.palette.gray[250],
  },
  expandedCabins: {
    display: 'flex',
    flexDirection: 'column',
    margin: '30px 0 30px 70px',
    [Theme.breakpoints.down('sm')]: {
      margin: '20px 20px 20px 50px',
    },
  },
  expandedAirportInfo: {
    position: 'relative',
    '& > p': {
      margin: '0',
      fontSize: Theme.typography.size[2],
      lineHeight: '150%',
      color: Theme.palette.gray[750],
      display: 'flex',
    },
    '& > img, & > svg': {
      position: 'absolute',
      left: '-35px',
    },
    [Theme.breakpoints.down('xl')]: {
      display: 'block',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  expandedAirportInfoSmall: {
    position: 'relative',
    '& > p': {
      margin: '0',
      fontSize: Theme.typography.size[2],
      lineHeight: '150%',
      color: Theme.palette.gray[750],
      display: 'flex',
    },
    '& > img, & > svg': {
      position: 'absolute',
      left: '-25px',
      top: '2px',
    },
    [Theme.breakpoints.down('xl')]: {
      display: 'none',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  multiAirlineLogo: {
    width: '25px',
    [Theme.breakpoints.down('sm')]: {
      width: '16px',
    },
  },
  airportLabelSmall: {
    marginLeft: '34px !important',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: '350px',
    display: 'block !important',
    [Theme.breakpoints.down('sm')]: {
      maxWidth: '290px',
    },
    [Theme.breakpoints.down('xs')]: {
      maxWidth: '230px',
    },
  },
  layoverDays: {
    fontSize: 'smaller',
    position: 'relative',
    top: '-5px',
  },
  expandedDepartIcon: {
    color: Theme.palette.gray[500],
    marginRight: '10px',
  },
  expandedFlightDuration: {
    display: 'flex',
    flexDirection: 'row',
    [Theme.breakpoints.down('sm')]: {
      marginLeft: '8px',
    },
  },
  expandedDurationIcons: {
    color: Theme.palette.gray[500],
    display: 'flex',
    flexDirection: 'column',
    marginRight: '10px',
    [Theme.breakpoints.down('sm')]: {
      borderLeft: `5px dotted ${Theme.palette.gray[500]}`,
      position: 'relative',
      top: '-10px',
    },
  },
  expandedDuration: {
    alignSelf: 'center',
    color: Theme.palette.gray[500],
    fontSize: Theme.typography.size[1],
    lineHeight: '150%',
    display: 'flex',
    [Theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      margin: '20px 0 20px 10px',
    },
  },
  expandedDurationLabel: {
    alignSelf: 'center',
    [Theme.breakpoints.down('sm')]: {
      alignSelf: 'flex-start',
    },
  },
  expandedFlightInfo: {
    marginTop: '20px',
    marginLeft: '34px',
    fontSize: `${Theme.typography.size[1]} !important`,
    fontSizeAdjust: 'none !important',
    textSizeAdjust: 'none !important',
    '& > p': {
      color: Theme.palette.gray[500],
      fontSize: `${Theme.typography.size[1]} !important`,
      fontSizeAdjust: 'none !important',
      textSizeAdjust: 'none !important',
      lineHeight: '150%',
      margin: '0',
      [Theme.breakpoints.down('sm')]: {
        fontSize: `${Theme.typography.size[1]} !important`,
      },
    },
  },
  expandedLayover: {
    color: Theme.palette.gray[500],
    fontSize: `${Theme.typography.size[1]} !important`,
    fontSizeAdjust: 'none !important',
    textSizeAdjust: 'none !important',
    lineHeight: '125%',
    margin: '30px 40px 0 34px',
    [Theme.breakpoints.down('sm')]: {
      margin: '20px 0 0 34px',
      fontSize: `${Theme.typography.size[1]} !important`,
    },
  },
  overnightLayover: {
    color: Theme.palette.error.main,
    borderColor: Theme.palette.error.main,
    marginLeft: '20px',
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[1],
    lineHeight: '17px',
    '& > svg': {
      color: `${Theme.palette.error.main} !important`,
      marginLeft: '10px !important',
      width: '18px !important',
    },
    [Theme.breakpoints.down('md')]: {
      marginTop: '0',
    },
    [Theme.breakpoints.down('sm')]: {
      marginTop: '5px',
      fontSize: Theme.typography.size[0],
    },
    [Theme.breakpoints.down('xs')]: {
      marginTop: '15px',
      marginLeft: '0px',
    },
  },
  expandedLayoverDuration: {
    margin: '20px 0',
  },
  upperVertical: {
    top: '3px',
    position: 'relative',
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  lowerVertical: {
    top: '-3px',
    position: 'relative',
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  expandedChooseCabinTitle: {
    '& > p': {
      color: Theme.palette.gray[750],
      fontSize: Theme.typography.size[2],
      lineHeight: '150%',
      margin: '0',
      display: 'inline-flex',
    },
  },
  expandedChooseCabinIcon: {
    color: Theme.palette.gray[500],
    marginRight: '10px',
  },
  expandedCabinsCard: {
    margin: '30px 30px 20px 34px',
    '&:last-child': {
      marginBottom: '0',
    },
    [Theme.breakpoints.down('sm')]: {
      margin: '20px 0 20px 34px',
      minWidth: 'auto',
      '&:last-child': {
        marginBottom: '0',
      },
    },
  },
  cabinCardContainer: {
    border: `1px solid ${Theme.palette.gray[250]}`,
    marginBottom: '20px',
    borderRadius: '5px',
  },
  contentContianer: {
    width: '100%',
  },
  cabinCard: {
    border: `1px solid ${Theme.palette.gray[250]}`,
    borderRadius: '5px',
    display: 'flex',
    marginBottom: '20px',
    position: 'relative',
  },
  test: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flightDetailsModal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flightDetailsClose: {
    color: Theme.palette.primary.light,
    height: '30px',
    position: 'absolute',
    right: '30px',
    top: '30px',
    width: '30px',
    [Theme.breakpoints.down('sm')]: {
      right: '20px',
    },
  },
  expandedItineraryModal: {
    margin: '30px 118px 30px 105px',
    '&:last-child': {
      marginBottom: '70px',
    },
    [Theme.breakpoints.down('lg')]: {
      marginRight: '88px',
    },
    [Theme.breakpoints.down('md')]: {
      marginRight: '63px',
    },
    [Theme.breakpoints.down('sm')]: {
      margin: '30px 30px 30px 45px',
      '&:last-child': {
        marginBottom: '50px',
      },
    },
  },
  amenitiesDetailsBody: {
    backgroundColor: Theme.palette.white,
    boxShadow: `0 2px 4px 0 ${Theme.palette.shadowOpacity}`,
    maxHeight: '700px',
    outline: 'none',
    fontFamily: Theme.typography.base.regular,
    position: 'absolute',
    width: '860px',
    overflow: 'auto',
    [Theme.breakpoints.down('lg')]: {
      width: '780px',
    },
    [Theme.breakpoints.down('md')]: {
      width: '90%',
      maxHeight: '95%',
    },
  },
  modalAmenitiesTitle: {
    color: Theme.palette.primary.main,
    display: 'flex',
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[6],
    lineHeight: '150%',
    margin: '70px 70px 0 70px',
    [Theme.breakpoints.down('sm')]: {
      margin: '60px 30px 20px 20px',
      fontSize: Theme.typography.size[3],
    },
  },
  modalAmenitiesSpanTitle: {
    marginLeft: '10px',
  },
  content: {
    height: '135px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '&:last-child': {
      marginBottom: '0',
    },
    position: 'relative',
    [Theme.breakpoints.down('lg')]: {
      height: '190px',
    },
    [Theme.breakpoints.down('sm')]: {
      height: 'unset',
      minHeight: '238px',
      flexDirection: 'column',
      padding: '20px',
    },
  },
  amenitiesLink: {
    marginLeft: '20px',
    marginBottom: '20px',
    [Theme.breakpoints.up('sm')]: {
      marginLeft: '30px',
    },
    '& button': {
      fontFamily: Theme.typography.base.regular,
      color: Theme.palette.primary.light,
      fontSize: Theme.typography.size[2],
    },
  },
  amenitiesItemList: {
    display: 'flex',
    margin: '8px 0px',
    alignItems: 'center',
    '& > div': {
      height: 'auto',
      [Theme.breakpoints.up('sm')]: {
        height: '20px',
      },
    },
    '& img': {
      marginRight: '8px',
    },
  },
  cabinClassColorCode: {
    borderRadius: '4px 0 0 4px',
    height: '100%',
    left: '0',
    position: 'absolute',
    top: '0',
    width: '10px',
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  economy: {
    backgroundColor: '#EAF3FF',
  },
  premiumEconomy: {
    backgroundColor: '#B2D1FE',
  },
  business: {
    backgroundColor: '#508DE4',
  },
  firstClass: {
    backgroundColor: '#508DE4',
  },
  cabinType: {
    marginRight: '130px',
    minWidth: '283px',
    '& > h3': {
      color: Theme.palette.primary.main,
      fontSize: Theme.typography.size[3],
      lineHeight: '150%',
      margin: '0',
    },
    '& > p': {
      color: Theme.palette.gray[750],
      fontSize: Theme.typography.size[1],
      lineHeight: '150%',
      margin: '10px 0 0 0',
    },
    [Theme.breakpoints.down('lg')]: {
      marginRight: '0',
      minWidth: '0',
    },
  },
  cabinTypeInfo: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '30px',
    flexGrow: '1',
    alignItems: 'center',
    [Theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    [Theme.breakpoints.down('sm')]: {
      alignSelf: 'flex-start',
      margin: '0',
      width: '100%',
    },
  },
  cabinPriceInfo: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '30px',
    alignItems: 'center',
    justifyContent: 'center',
    [Theme.breakpoints.down('sm')]: {
      margin: '0',
      width: '100%',
    },
  },

  cabinInfo: {
    '& > p': {
      color: Theme.palette.gray[750],
      fontSize: Theme.typography.size[1],
      lineHeight: '150%',
      marginTop: '10px',
    },
  },
  cabinPaymentOptions: {
    fontSize: Theme.typography.size[1],
    lineHeight: '150%',
    [Theme.breakpoints.down('xl')]: {
      display: 'block',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    '& div': {
      display: 'inline',
    },
  },
  cabinPaymentOptionsSmall: {
    margin: '10px 0 20px 0',
    '& > p': {
      color: Theme.palette.gray[750],
      fontSize: Theme.typography.size[2],
      lineHeight: '150%',
      margin: '0',
    },
    [Theme.breakpoints.down('xl')]: {
      display: 'none',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  cabinBaggage: {
    display: 'flex',
    flexDirection: 'column',
    '& > p': {
      fontSize: Theme.typography.size[1],
      lineHeight: '150%',
      margin: '0',
    },
    [Theme.breakpoints.down('lg')]: {
      marginTop: '20px',
    },
    [Theme.breakpoints.down('sm')]: {
      marginTop: '0',
      width: '100%',
      '& > p': {
        marginTop: '10px',
      },
    },
  },
  cabinBaggageLabel: {
    alignItems: 'center',
    color: Theme.palette.gray[750],
    display: 'flex',
    flexDirection: 'row',
    '& > svg': {
      marginRight: '10px',
    },
  },
  cabinBaggageTooltip: {
    color: Theme.palette.gray[750],
    fontSize: Theme.typography.size[1],

    display: 'flex',
    alignItems: 'center',

    '& svg': {
      color: Theme.palette.primary.light,
    },

    [Theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      marginBottom: '30px',
      fontSize: Theme.typography.size[2],
    },
  },
  tooltipLabel: {
    color: Theme.palette.gray[750],
    flexGrow: '1',
    [Theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
    '& svg': {
      marginBottom: '-5px',
      marginLeft: '4px',
      cursor: 'pointer',
      color: Theme.palette.primary.light,
      width: 16,
    },
  },
  seatsLeft: {
    color: '#FF434E',
    fontSize: Theme.typography.size[1],
    lineHeight: '150%',
  },
  cabinSeatsLeft: {
    [Theme.breakpoints.down('xl')]: {
      display: 'block',
      margin: '0',
      marginTop: '10px',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  cabinSeatsLeftSmall: {
    [Theme.breakpoints.down('xl')]: {
      display: 'none',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  baggageTooltip: {
    maxWidth: '250px',
  },
  baggageTooltipTitle: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    color: Theme.palette.primary.main,
    marginBottom: '20px',
  },
  baggageTooltipBags: {
    fontFamily: Theme.typography.base.regular,
    display: 'flex',
    fontSize: Theme.typography.size[2],
    color: Theme.palette.gray[750],
    marginBottom: '10px',
    '& span': {
      lineHeight: '150%',
    },
    '& span:first-child': {
      flexGrow: '1',
    },
    '& span:last-child': {
      textAlign: 'right',
    },
  },
  baggageTooltipAdditionalInfo: {
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[0],
    color: Theme.palette.gray[750],
    marginTop: '20px',
  },
  fareTooltipContainer: {
    maxWidth: 'unset',
    '& > div': {
      [Theme.breakpoints.down('lg')]: {
        paddingTop: '40px',
        '& > button': {
          top: '20px',
        },
      },
    },
    [Theme.breakpoints.down('sm')]: {
      marginLeft: '15px !important',
    },
  },
  fareTooltip: {
    width: '440px',
    [Theme.breakpoints.down('sm')]: {
      width: 'calc(100vw - 80px)',
      maxWidth: '440px',
    },
  },
  fareTooltipTitle: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[1],
    color: Theme.palette.primary.main,
  },
  fareTooltipSubtitle: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[1],
  },
  fareTooltipRow: {
    fontFamily: Theme.typography.base.regular,
    display: 'flex',
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[750],
    marginBottom: '20px',
    marginTop: '20px',
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[0],
    },
    '&:first-child': {
      marginBottom: '10px',
      marginTop: '0px',
    },
    '&:last-child': {
      marginBottom: '0px',
    },
    '& span': {
      lineHeight: '150%',
      width: '50%',
      '&:first-child': {
        [Theme.breakpoints.down('xs')]: {
          width: '40%',
        },
      },
      '&:last-child': {
        marginLeft: '50px',
        [Theme.breakpoints.down('sm')]: {
          marginLeft: '40px',
        },
        [Theme.breakpoints.down('xs')]: {
          width: '60%',
        },
      },
    },
  },
}));

export default useStyles;
